import { useCallback, useMemo } from "react";

import { useLibrary } from "../../../providers";
import {
  useRequestWithFeedback,
  type OverrideRunProps,
} from "../../../composites";

import { API as SearchAPI } from "./api";

import type { CreateGlobalSearchResponse } from "./types";

export const useCreateSearch = () => {
  const { send, loading } =
    useRequestWithFeedback<CreateGlobalSearchResponse>();
  const l10n = useLibrary("translations");
  const checkPlatform = useLibrary("platform");
  const platform = useMemo(
    () => (checkPlatform.get() === "web" ? "web" : "mobile"),
    [checkPlatform],
  );

  const createSearch = useCallback(
    (
      searchQuery: string,
      overrideRunProps?: OverrideRunProps<CreateGlobalSearchResponse>,
    ) => {
      send({
        action: SearchAPI.createSearch(searchQuery, platform),
        messaging: {
          toast: {
            error: l10n.getString("search-create-error"),
          },
        },
        ...overrideRunProps,
      });
    },
    [l10n, platform, send],
  );

  return { createSearch, loading };
};
